export const getListOfGatewayAndPriceEmail = {
  GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_REQUEST: "GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_REQUEST",
  GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_SUCCESS: "GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_SUCCESS",
  GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_ERROR: "GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_ERROR",
};
